import { Directive, ElementRef, OnInit, inject, input, signal } from '@angular/core'

import {
  FormFieldScopedRole,
  FormFieldsEnum,
  getFormFieldScopeGroup,
  getScopedThemeComponent,
  theme,
} from '@flowx/core-sdk'
import { getComponentStyles } from '@flowx/core-theme'

@Directive({
  selector:
    'flx-label[flxScopedVariant], flx-helper[flxScopedVariant], flx-error[flxScopedVariant]',
  standalone: true,
  host: {
    '[class]': 'scopedClassName()',
  },
})
export class FlxFormFieldScopedVariantDirective implements OnInit {
  #element = inject(ElementRef).nativeElement

  flxScopedVariant = input<FormFieldsEnum | undefined>()

  scopedClassName = signal<string>('')

  ngOnInit(): void {
    const tag = (this.#element.tagName as string).toLowerCase()
    const role: FormFieldScopedRole =
      tag === 'flx-label' ? 'label' : tag === 'flx-error' ? 'error' : 'helper'

    const identifier = this.flxScopedVariant()
    const scopedComponent = getScopedThemeComponent(identifier, role)
    const group = getFormFieldScopeGroup(identifier)
    if (!scopedComponent || !group) {
      return
    }

    const themeClass = getComponentStyles(scopedComponent, theme())
    const modifierClass = `flx-form-field-${role}-${group}`
    this.scopedClassName.set(`${themeClass ?? ''} ${modifierClass} flx-themed`.trim())
  }
}
